import IService from "@api/iService";
import {ICumulativeBonus, IDonateBonus, IPaymentSettings} from "@interfaces/user/payments";
import {UserPayment, UserPaymentView} from "@models/user/payments";

export default class PaymentsService extends IService {

    async getBonuses() {
        return await this.getApi<IDonateBonus[]>('/api/user/payments/bonus/');
    }

    async getBonus(id: string) {
        return await this.getApi<IDonateBonus>(`/api/user/payments/bonus/${id}/`);
    }

    async donateRequest(donate: UserPayment) {
        return await this.postApi<UserPaymentView>('/api/user/payments/donate/', donate);
    }

    getPaymentSettings() {
        return this.getApi<IPaymentSettings>('/api/user/payments/settings/');
    }

    getCumulativeBonus() {
        return this.getApi<ICumulativeBonus>('/api/user/payments/bonus/cumulative/');
    }
}